import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
export class ServicesDepartureReport {
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
   let request = JSON.parse(webcontext.RequestBody);
   if(webcontext.ConfigType.toLowerCase()=="form"){
      request["a_FK_TBScheduleNormal_ID"]= webcontext.ID;
    if(typeof(request.a_FK_TBDepartureReport_ID)=="undefined"){
      webcontext.ResponseMessage.Success = false;
      webcontext.ResponseMessage.ErrorMessage = "离岗报备必须选择一个";
      }
      webcontext.RequestBody = JSON.stringify(request);
   }
    //   let datepie:DatePipe =new DatePipe("en-US");
    //      let nowdate = datepie.transform(new Date(),"yyyy-MM-dd");
    //     request["a_FK_SystemUser_ID"]= webcontext.Account.Id;//被排班人ID
    //     if(typeof(request.a_FK_Store_ID)=="undefined"){//排班门店
    //       webcontext.ResponseMessage.ErrorMessage ="排班门店必选";
    //       webcontext.ResponseMessage.Success = false;
    //     }else
    //     if(typeof(request.a_FK_TBScheduleType_ID)=="undefined"){//排班类型
    //       webcontext.ResponseMessage.ErrorMessage ="排班类型必选";
    //       webcontext.ResponseMessage.Success = false;
    //     }else
    //     if(typeof(request.a_SNStartDate)=="undefined"){//排班开始日期
    //       webcontext.ResponseMessage.ErrorMessage ="开始时间不能为空";
    //       webcontext.ResponseMessage.Success = false;
    //     }else
    //     if(typeof(request.a_SNEndDate)=="undefined"){//排班结束日期
    //       webcontext.ResponseMessage.ErrorMessage ="结束时间不能为空";
    //       webcontext.ResponseMessage.Success = false;
    //     }else
    //     if(typeof(request.a_SNStartDate)!="undefined" && typeof(request.a_SNEndDate)!="undefined"){
    //       if (!this.compareDate(request['a_SNStartDate'], request['a_SNEndDate'])) {
    //         webcontext.ResponseMessage.Success = false;
    //         webcontext.ResponseMessage.ErrorMessage = "结束时间不得小于或等于开始时间";
    //     } 
    //     request.a_SNStartDate = nowdate+" "+request.a_SNStartDate;
    //     request.a_SNEndDate = nowdate+" "+request.a_SNEndDate;
    //     }
    
    
    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
   const that = this;
    return webContext
  }
  
  private compareDate(begin, end) {
    const b1 = begin.replace(':','');
    const e1 = end.replace(':','');
    if (b1 >= e1) {
        return false;
    } else {
        return true;
    }
}
}